import { render, staticRenderFns } from "./ComicContent.vue?vue&type=template&id=1f32e5fb&scoped=true&"
import script from "./ComicContent.vue?vue&type=script&lang=js&"
export * from "./ComicContent.vue?vue&type=script&lang=js&"
import style0 from "./ComicContent.vue?vue&type=style&index=0&id=1f32e5fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f32e5fb",
  null
  
)

export default component.exports